import React, { Component } from "react";
import { NavLink, withRouter } from 'react-router-dom'
import pubsub from 'pubsub-js'
import tipAlert from "../../../Login/BsyAlertTip/Staticize";

import { ReactSortable } from "react-sortablejs";
import { BsyUtils } from '../../../utils/Utils';
import './index.css';

class BsyDashboardAppMenu extends Component {

  constructor(props) {
    super(props)
    this.state = {
      menuapps: props.appsCache.length > 0 ? props.appsCache : this._appsExt(props.apps),
      appid: props.appid,
      entryid: props.entryid,
      type: props.type,
      routePath: props.routePath,
      apps: [], //整个账号下所有的app
    }
  }

  componentDidMount = () => {
    if (this.props.getContext) {
      this.props.getContext(this);
    }
    this.reAppMenu = pubsub.subscribe('reAppMenu', (topic, message) => {
      let reAppMenu = [];
      this.state.menuapps && this.state.menuapps.length > 0 && this.state.menuapps.map((res) => {
        if (res._id === message.appId) {
          if (message.reName) {
            res.appname = message.reName
          }
          if (message.reStyle) {
            res.style = message.reStyle
          }
        }
        reAppMenu.push(res)
        return res;
      })
      this.setState({
        menuapps: this.renderMenuShow(reAppMenu)
      }, () => {
        this._setCache()
      })
    })
    this.removeAppMenu = pubsub.subscribe('removeAppMenu', (topic, message) => {
      this.deleteApp(message.appData, message.type)
    })
  }

  componentWillUnmount() {
    pubsub.unsubscribe(this.reAppMenu)
    pubsub.unsubscribe(this.removeAppMenu)
  }

  findApp = (appid, apps) => {
    let app = {};
    apps.map((data, index) => {
      if (data.apps) {
        data.apps.map((dd) => {
          if (dd._id === appid) {
            app = { ...dd };
          }
          return dd;
        })
      }
      return null;
    })
    return app;
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    const { appid, type, entryid, groupid } = nextProps;
    // React.axios('/dashboard/app_group/list').then(res => {
    //   let apps = res.data.dock_items ? [...res.data.items, ...res.data.dock_items] : [...res.data.items];
    //   let menuapps = [...(nextProps.appsCache.length > 0 ? this._getCache(apps) : this._appsExt(apps))]
    //   if (appid && !this.hasApp({_id: appid})) {
    //     //应用不存在
    //     const app = this.findApp(appid, apps)
    //     if (!BsyUtils.isObjectEmpty(app)) {

    //       let cacheapps = null; //记录非ding缓存
    //       let newapp = [];
    //       let isinsert = false;
    //       for (let index = 0; index < menuapps.length; index++) {
    //         let data = menuapps[index];
    //         // if (data.isding) {
    //         //     newapp.push({ ...data })
    //         // } else
    //         // {
    //         if (!isinsert) {
    //           newapp.push({...app})
    //           cacheapps = {...data};
    //           isinsert = true;
    //         } else {
    //           newapp.push({...cacheapps})
    //           cacheapps = {...data};
    //         }
    //         // }
    //       }
    //       if (cacheapps)
    //         newapp.push(cacheapps)
    //       if (!isinsert) {
    //         newapp.push(app)
    //       }
    //       menuapps = [...newapp];

    //       //没有了钉的操作 屏蔽
    //       // while (1) {
    //       //     //递归判断
    //       //     const { isok, apps } = this.reckonMenuApps(menuapps, app);
    //       //     if (isok) {
    //       //         menuapps = [...apps];

    //       //         menuapps.shift();
    //       //         menuapps.push(app)

    //       //         break;
    //       //     } else {
    //       //         menuapps = [...apps];
    //       //     }
    //       //     if (menuapps.length === 0)
    //       //         break
    //       // }

    //     }
    //   }

    //   let newmenuapps = this.renderMenuShow(menuapps);
    //   let appNum = 0;
    //   let hasCreateApp = false;
    //   apps.map(res2 => {
    //     appNum += res2.appcount
    //   })
    //   if (appNum === 0) {
    //     hasCreateApp = (BsyUtils.isCorpOwn() || BsyUtils.isSysManager()) && appNum === 0;
    //   }
    //   const ppp = {
    //     menuapps: newmenuapps,
    //     appid: appid,
    //     type: type,
    //     routePath: nextProps.routePath,
    //     entryid: entryid,
    //     groupid: groupid,
    //     apps: [...apps],
    //     hasCreateApp
    //     // appid: nextProps.appid !== '' ? nextProps.appid : nextProps.appsCache.length > 0 ? nextProps.appsCache[0]._id : '',
    //   }
    //   this.setState(ppp, () => {
    //     this._setCache();
    //     // this.repairMenu()
    //   })
    // })



    let menuapps = [...(nextProps.appsCache.length > 0 ? this._getCache(nextProps.apps) : this._appsExt(nextProps.apps))]
    if (appid && !this.hasApp({ _id: appid })) {
      //应用不存在
      const app = this.findApp(appid, nextProps.apps)
      if (!BsyUtils.isObjectEmpty(app)) {

        let cacheapps = null; //记录非ding缓存
        let newapp = [];
        let isinsert = false;
        for (let index = 0; index < menuapps.length; index++) {
          let data = menuapps[index];
          // if (data.isding) {
          //     newapp.push({ ...data })
          // } else
          // {
          if (!isinsert) {
            newapp.push({ ...app })
            cacheapps = { ...data };
            isinsert = true;
          } else {
            newapp.push({ ...cacheapps })
            cacheapps = { ...data };
          }
          // }
        }
        if (cacheapps)
          newapp.push(cacheapps)
        if (!isinsert) {
          newapp.push(app)
        }
        menuapps = [...newapp];

        //没有了钉的操作 屏蔽
        // while (1) {
        //     //递归判断
        //     const { isok, apps } = this.reckonMenuApps(menuapps, app);
        //     if (isok) {
        //         menuapps = [...apps];

        //         menuapps.shift();
        //         menuapps.push(app)

        //         break;
        //     } else {
        //         menuapps = [...apps];
        //     }
        //     if (menuapps.length === 0)
        //         break
        // }

      }
    }

    let newmenuapps = this.renderMenuShow(menuapps);
    let appNum = 0;
    let hasCreateApp = false;
    nextProps.apps.map(res2 => {
      appNum += res2.appcount;
      return null;
    })
    if (appNum === 0) {
      hasCreateApp = (BsyUtils.isCorpOwn() || BsyUtils.isSysManager()) && appNum === 0;
    }
    const ppp = {
      menuapps: newmenuapps,
      appid: appid,
      type: type,
      routePath: nextProps.routePath,
      entryid: entryid,
      groupid: groupid,
      apps: [...nextProps.apps],
      hasCreateApp
      // appid: nextProps.appid !== '' ? nextProps.appid : nextProps.appsCache.length > 0 ? nextProps.appsCache[0]._id : '',
    }
    this.setState(ppp, () => {
      this._setCache();
      // this.repairMenu()
    })


  }

  //把apps 展开
  _appsExt = (items, appid) => {
    let apps = [];
    items.map((data, index) => {
      data.apps.map((data1, index) => {
        apps.push(data1);
        return null;
      })
      return null;
    })
    return [...apps]
  }

  //应用是否选择显示在标签了
  hasApp = (appinfo) => {
    const { menuapps } = this.state;
    const finds = menuapps.filter((data, index) => {
      return data.show && data._id === appinfo._id;
    })
    return !!finds.length;
  }

  //确保拿到最新的数据
  _getCache = (items) => {
    var key = "_applist_" + window.FX.STATIC.user._id + window.FX.STATIC.corpId;
    let apps = BsyUtils.Store.get(key) || [];
    if (BsyUtils.isObjectEmpty(apps)) {
      key = "_applist_" + window.FX.STATIC.corpId;
      apps = BsyUtils.Store.get(key) || [];
    }
    let appsCache = [];
    apps.map((data, index) => {
      const { result, dd } = this._findAppCache(items, data._id)
      if (result) {
        appsCache.push({ ...dd, isding: data.isding });
      }
      return null;
    })
    this.appMap = null;
    return appsCache;
  }

  _findAppCache = (items, appid) => {
    if (!this.appMap) {
      this.appMap = {};
      items.map((data, index) => {
        data.apps.map((data1, index) => {
          this.appMap[data1._id] = data1;
          return null;
        })
        return null;
      })
    }

    return {
      result: !!this.appMap[appid],
      dd: this.appMap[appid],
    }

  }

  //有多少个钉的状态
  dingCount = () => {
    const { menuapps } = this.state;
    let dingnum = 0;
    menuapps.map((data, index) => {
      data.isding && dingnum++;
      return null;
    })
    return dingnum
  }

  //执行钉操作 ，执行钉操作后，应用焦点自动排到第一
  Ding = (appinfo) => {

    const { menuapps } = this.state;

    // this.selectApp(appinfo)
    if (!appinfo.isding && this.dingCount() >= 3) {
      tipAlert({
        type: "warning",
        msg: "最多只能钉三个应用"
      })
      return
    }

    let newapp = menuapps.map((v) => {
      if (v._id === appinfo._id) {
        v.isding = !v.isding;
      }
      return v;
    })

    this.setState({
      // appid: appid,
      menuapps: this.renderMenuShow(newapp),
    }, () => {
      this._setCache();
    })
  }

  //延时检测与修复 ？？ 因为UI没有绘制完成 界面不完善
  repairMenu = () => {
    let _this = this;
    setTimeout(() => {
      _this.setState({
        menuapps: this.renderMenuShow(_this.state.menuapps),
      }, () => {
        this._setCache();
      })
    }, 100)
  }

  deleteApp = (appinfo, type) => {

    const { menuapps } = this.state;
    const finds = menuapps.filter((v) => {
      return v._id !== appinfo._id
    })
    if (finds.length <= 0 && type !== "delApp") {
      tipAlert({
        type: "warning",
        msg: "工作台至少保留一个可见应用"
      })
      return;
    }
    window.FX.FORMCACHE && window.FX.FORMCACHE.saveFormData();
    let dd = this.renderMenuShow(finds);
    this.setState({
      menuapps: dd,
    }, () => {
      this._setCache()

      if (dd.length === 0) {
        window.location.href = window.rootDirectroy + '/';
        return
      }

      if (type === "delApp") {
        return
      }


      let appid = this.state.appid;
      if (!appid) {
        this.props.history.push(window.rootDirectroy + '/team/app/' + dd[0]._id)
        return
      }
      if (appid === appinfo._id) {
        this.props.history.push(window.rootDirectroy + '/team/app/' + finds[0]._id)
      }
    })

  }


  //在全部应用中选择应用
  selectApp = (appinfo) => {

    if (appinfo._id === this.state.appid)
      return;

    window.FX.FORMCACHE && window.FX.FORMCACHE.saveFormData();

    const { menuapps } = this.state;
    // this.props.onSelectApp && this.props.onSelectApp(appinfo);
    if (!appinfo) {
      this.setState({
        appid: "",
      })
      return;
    }
    let appid = appinfo._id;
    if (this.hasApp(appinfo)) {
      this.setState({
        appid: appinfo._id,
      }, () => {
        this._setCache();
        let appCache = BsyUtils.getEntryCache(appinfo._id);
        if (BsyUtils.isObjectEmpty(appCache)) {
          this.props.history.push(window.rootDirectroy + '/team/app/' + appinfo._id)
        } else {
          this.props.history.push(`${window.rootDirectroy}/team/app/${appCache.appid}/${appCache.type}/${appCache.entryid}`)
        }

      })

      return;
    }

    let finds = menuapps.filter((v) => {
      return v._id !== appinfo._id
    })

    let newapp = []
    if (finds.length === 0) {
      newapp.push(appinfo)
    } else {
      finds.map((data, index) => {
        if (appinfo) {
          if (!data.isding) {
            newapp.push(appinfo)
            appinfo = null;
          }
        }
        newapp.push(data)
        return null;
      })
    }


    // [{...appinfo},...apps];

    this.setState({
      appid: appid,
      menuapps: this.renderMenuShow(newapp),
    }, () => {
      this._setCache();
      let appCache = BsyUtils.getEntryCache(appid);
      if (BsyUtils.isObjectEmpty(appCache)) {
        this.props.history.push(window.rootDirectroy + '/team/app/' + appid)
      } else {
        this.props.history.push(window.rootDirectroy + `/team/app/${appCache.appid}/${appCache.type}/${appCache.entryid}`)
      }
    })
  }

  _setCache = (menuapps) => {
    var key = "_applist_" + window.FX.STATIC.user._id + window.FX.STATIC.corpId;
    let newMenuapps = [...(menuapps ? menuapps : this.state.menuapps)]
    BsyUtils.Store.set(key, newMenuapps)
  }

  //估算 ding 是否刚好显示在菜单上
  reckonMenuApps = (apps, curApp) => {

    if (!document.querySelector('.bsy-menu-pane')) {
      return
    }

    let width = document.querySelector('.bsy-menu-pane').offsetWidth - 30 - (document.querySelector('.right-menu') ? document.querySelector('.right-menu').offsetWidth : 0) - (document.querySelector('.left-menu') ? document.querySelector('.left-menu').offsetWidth : 0);
    width -= 80 //减掉 全部应用按钮的 占宽
    let isok = false;

    //90 偏移宽度
    let offset = 90;

    let newapps = [];
    let sunWidth = 0;
    for (let index = 0; index < apps.length; index++) {
      let data = apps[index]
      if (data.todonum)
        offset = 96;
      else
        offset = 90;

      let appwidth = BsyUtils.getSpanTextWidth(data.appname) + offset + (data.todonum ? BsyUtils.getSpanTextWidth("(" + data.todonum + ")") : 0)
      sunWidth += appwidth;
      data.show = sunWidth <= width;
      if (data.show) {
        newapps.push({ ...data })
      } else {
        break;
      }
    }
    if (newapps.length === apps.length) {
      return {
        isok: true,
        apps: newapps,
      }
    }
    newapps = [...apps];
    // let dd = newapps.filter((data)=>{
    //     if(data._id == curApp._id) {
    //         return true;
    //     }
    //     return false;
    // })

    let isdel = false;
    for (let index = newapps.length - 1; index >= 0; index--) {
      const element = newapps[index];
      if (!element.isding && element._id !== curApp._id) {
        newapps.splice(index, 1)
        isdel = true;
        break;
      }
    }
    //可能全部是钉的状态
    if (!isdel) {
      if (newapps[newapps.length - 1]._id !== curApp._id)
        newapps.splice(newapps.length - 1, 1)
      else {
        newapps.splice(newapps.length - 2, 1)
      }
    }

    return {
      isok: isok,
      apps: newapps,
    }
  }

  // 重绘 可显示的应用数量
  renderMenuShow = (apps) => {
    //计算当前可以使用的宽度 - 40 预留更多菜单的宽度
    if (!document.querySelector('.bsy-menu-pane')) {
      return
    }
    // let width = document.querySelector('.bsy-menu-pane').offsetWidth - 30 - (document.querySelector('.right-menu') ? document.querySelector('.right-menu').offsetWidth : 0) - (document.querySelector('.left-menu') ? document.querySelector('.left-menu').offsetWidth : 0);
    // width -= 80 //减掉 全部应用按钮的 占宽

    let menuwidth = document.querySelector('.bsy-menu-pane') ? document.querySelector('.bsy-menu-pane').offsetWidth : 0
    let rightmenuwidth = document.querySelector('.right-menu') ? document.querySelector('.right-menu').offsetWidth : 0
    let leftmenuwidth = (document.querySelector('.left-menu') ? document.querySelector('.left-menu').offsetWidth : 0) + 20 //20 margin-right: 20px;
    let allMenuWidth = document.querySelector('.items.more') ? document.querySelector('.items.more').offsetWidth : 0
    // console.log('bsy-menu-pane', menuwidth);
    // console.log('right-menu', rightmenuwidth);
    // console.log('left-menu', leftmenuwidth);
    // console.log('allMenu', allMenuWidth);
    // console.log('center-menu', menuwidth - rightmenuwidth - leftmenuwidth);
    let width = menuwidth - rightmenuwidth - leftmenuwidth - allMenuWidth - 45; // 45 是padding的占宽
    // console.log('center-menu1', width);

    //90 偏移宽度
    let offset = 90;
    let sunWidth = 0;
    let newapps = [];


    let appsid = [];


    for (let index = 0; index < apps.length; index++) {
      let data = apps[index]
      if (appsid.indexOf(data._id) > -1) {
        continue;
      }
      appsid.push(data._id)

      if (data.todonum)
        offset = 96;
      else
        offset = 76;
      //这里需要根据 菜单的实际情况调整字体的大小
      let appwidth = BsyUtils.getElTextWidth(data.appname, '15px') + offset // + (data.todonum ? BsyUtils.getElTextWidth("(" + data.todonum + ")") : 0)
      // console.log(data.appname, appwidth)
      sunWidth += appwidth;
      // console.log('sunWidth',sunWidth);
      data.show = sunWidth <= width;
      if (data.show) {
        newapps.push({ ...data })
      } else {
        break;
      }
    }

    return newapps
  }

  onAllApp = (event) => {

    window.FX.FORMCACHE && window.FX.FORMCACHE.saveFormData();
    window.$('.bsy-form-menu-tree').sortable("destroy")
  }

  renderAllAppBtn = () => {
    const { menuapps, apps, hasCreateApp } = this.state;

    if (BsyUtils.isNormalUser()) {
      let allapp = [];
      apps.map((data, index) => {
        if (data.apps) {
          data.apps.map((dd) => {
            allapp.push(dd)
            return null;
          })
        }
        return null;
      })
      if (allapp.length > 0 && menuapps.length === allapp.length) {
        return ''
      } else {
        // console.log(hasCreateApp)
        return (hasCreateApp ? <div className="createApp">
          <a className="group-box-item-add-blank-app" href={window.rootDirectroy + "/bsymember/appstore"}>
            <i className="icon-bsy-iconjia" />
            <span>{React.language('app.create.new')}</span>
          </a>
        </div> : <NavLink className="items more"
          to={{ pathname: window.rootDirectroy + "/team/apps", state: { seach: false } }}
        >
          <div className="inner-text" onClick={this.onAllApp}><span>{React.language('all')}</span></div>
        </NavLink>)
      }
    } else {
      // console.log(hasCreateApp)
      return (hasCreateApp ? <div className="createApp">
        <a className="group-box-item-add-blank-app" href={window.rootDirectroy + "/bsymember/appstore"}>
          <i className="icon-bsy-iconjia" />
          <span>{React.language('app.create.new')}</span>
        </a>
      </div> : <NavLink className="items more"
        to={{ pathname: window.rootDirectroy + "/team/apps", state: { seach: false } }}
      >
        <div className="inner-text" onClick={this.onAllApp}><span>{React.language('all')}</span></div>
      </NavLink>)
    }
  }

  onsetList = (evt) => {

    const { menuapps } = this.state;

    let d1 = menuapps.map((data) => {
      return data._id;
    })

    let d2 = evt.map((data) => {
      return data._id;
    })

    if (JSON.stringify(d2) !== JSON.stringify(d1)) {
      // console.log('onsetList', evt)
      this.setState({
        menuapps: [...evt]
      }, () => {
        this._setCache()
      })
    }

  }

  render() {
    const { menuapps, appid } = this.state;
    return (
      <div className={'dashboard-app-menu'}>
        {
          <ReactSortable

            style={{
              display: 'flex'
            }}

            // forceFallback={'true'}
            list={menuapps}
            setList={this.onsetList}

            // filter={'.iconding,.close'}
            handle={'.items'}

          >
            {
              menuapps.map((data) => {
                return !data.show ? <></> : <div
                  key={'menu -' + data._id}
                  className={'ddclick '}
                >
                  <div className="appItem">
                    <div className={'items ' + (data._id === appid ? ' select ' : '')} onMouseDown={e => {
                      e.stopPropagation();
                      e.preventDefault();
                      this.selectApp(data);
                    }}>
                      <div className={"app-icon color-cover-" + data.style.color}>
                        <div className={"imgbg-small-bsy-app imgbg-bsy-app-" + data.style.icon} />
                      </div>
                      <span>{data.appname}</span>
                    </div>
                    {
                      data.todonum ? <div className="todonum" title={data.todonum}>{"(" + data.todonum + ")"}</div> : ''
                    }
                    <div className="close" onClick={e => {
                      e.stopPropagation();
                      e.preventDefault();
                      this.deleteApp(data)
                    }}><i className="icon-dingding-guide-close" /></div>
                    {
                      //data.isding
                      //<div className={'iconding ' + (data.isding ? 'ding' : '')} onClick={e => { e.stopPropagation(); e.preventDefault(); this.Ding(data); }} />
                    }
                    {
                      data.dock && <div className="isDock">
                        {React.language("outside")}
                      </div>
                    }
                  </div>
                </div>
              })
            }

          </ReactSortable>

        }
        {
          this.renderAllAppBtn()
        }
      </div>
    )
  }
}

export default withRouter(BsyDashboardAppMenu)

